import { Overlay, ScrollStrategy } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { SearchOpportunitiesCalendarResult } from '@api-proxies';
import { OpportunityCalendarEvent } from '@models/enums/OpportunityCalendarEvent';
import { TabNames } from '@models/enums/TabNames';
import { CDK_IMPORTS } from '@utils/standalone-imports';
import { BadgeComponent } from 'ngx-lib';
import { PopupCardBaseLayoutComponent } from '../../popup-card-base-layout/popup-card-base-layout.component';
import { UserInfoComponent } from '../../user-info/user-info.component';
import { OpportunityCardExpandedComponent } from '../opportunity-card-expanded/opportunity-card-expanded.component';

@Component({
    selector: 'app-opportunity-card-compact',
    templateUrl: './opportunity-card-compact.component.html',
    styleUrls: ['./opportunity-card-compact.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        ...CDK_IMPORTS,
        BadgeComponent,
        PopupCardBaseLayoutComponent,
        UserInfoComponent,
        OpportunityCardExpandedComponent
    ]
})
export class OpportunityCardCompactComponent {
    @Input()
    data?: SearchOpportunitiesCalendarResult;

    @Input()
    size: 'minimal' | 'normal';
    isExpanded: boolean;

    dueDatetype: OpportunityCalendarEvent;
    followUpType: OpportunityCalendarEvent;

    protected scrollStrategy: ScrollStrategy;

    constructor(
        private readonly router: Router,
        private readonly overlay: Overlay
    ) {
        this.size = 'normal';
        this.isExpanded = false;
        this.dueDatetype = OpportunityCalendarEvent.DueDate;
        this.followUpType = OpportunityCalendarEvent.FollowUpContactDate;
        this.scrollStrategy = this.overlay.scrollStrategies.close();
    }

    onGoToClicked(id?: number): void {
        this.router.navigate([`/opportunities-single/${id}/${TabNames[TabNames.Overview]}`]);
    }

    onKeyDown(e: KeyboardEvent) {
        if (e.key === 'Enter' || e.key === 'Escape') {
            this.isExpanded = !this.isExpanded;
        }
    }
}
